export function getVoiceLongSilenceDelayMs() {
  if (import.meta.env.VITE_VOICE_LONG_SILENCE_ENABLED !== 'true') return 0
  const delay = Number(import.meta.env.VITE_VOICE_LONG_SILENCE_MS)
  return Number.isFinite(delay) && delay >= 5_000 ? delay : 0
}
